export const DEV_HOST: any = {
  ja: process.env.JA_DOMAIN
    ? `http://${process.env.JA_DOMAIN}`
    : "http://localhost:8000",
  en: process.env.EN_DOMAIN
    ? `http://${process.env.EN_DOMAIN}`
    : "http://en.localhost:8001",
  ko: process.env.KO_DOMAIN
    ? `http://${process.env.KO_DOMAIN}`
    : "http://ko.localhost:8002",
  zh_cn: process.env.CN_DOMAIN
    ? `http://${process.env.CN_DOMAIN}`
    : "http://zh-cn.localhost:8003",
  zh_tw: process.env.TW_DOMAIN
    ? `http://${process.env.TW_DOMAIN}`
    : "http://zh-tw.localhost:8004",
};

export const DEV_SERVER_HOST: any = {
  ja: "http://reverse-proxy:80",
  en: "http://reverse-proxy:81",
  ko: "http://reverse-proxy:82",
  zh_cn: "http://reverse-proxy:83",
  zh_tw: "http://reverse-proxy:84",
};

export const HOST: any = {
  ja: `https://${process.env.JA_DOMAIN}`,
  en: `https://${process.env.EN_DOMAIN}`,
  ko: `https://${process.env.KO_DOMAIN}`,
  zh_cn: `https://${process.env.CN_DOMAIN}`,
  zh_tw: `https://${process.env.TW_DOMAIN}`,
};

export const BASE_PATH = "";
export const LOCATION_BASE_PATH = "/engine";
export const API_BASE_PATH = "/engine/api";
export const PAYMENT_TOKEN_URL: string =
  process.env.APP_ENV === "production"
    ? "https://static.mul-pay.jp/ext/js/token.js"
    : "https://stg.static.mul-pay.jp/ext/js/token.js";

export const GMO_SHOP_ID: string =
  process.env.APP_ENV === "production" ? "9200003913227" : "tshop00028565";

export const HUBSPOT_PORTAL_ID =
  process.env.APP_ENV === "production" ? "20850271" : "20885317";
export const HUBSPOT_FORM_ID =
  process.env.APP_ENV === "production"
    ? "fd015c8c-86ca-4232-853f-dc08c465c038"
    : "efa07065-467a-4369-ac82-4f4321939e29";

export const LINE_LIFF_SDK_URL =
  "https://static.line-scdn.net/liff/edge/2/sdk.js";
